import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

// Add TypeScript declaration for ReactNativeWebView
declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void
    }
  }
}

export default function QuestionCravingPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Send message to React Native WebView that onboarding is complete
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'ONBOARDING_COMPLETE',
        }),
      )
      return
    }

    // Continue with normal form submission
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionCraving.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionCraving.button1'),
          value: 'healthy_light',
        },
        {
          text: t('pages.onboarding.questionCraving.button2'),
          value: 'comfort_food',
        },
        {
          text: t('pages.onboarding.questionCraving.button3'),
          value: 'quick_easy',
        },
        {
          text: t('pages.onboarding.questionCraving.button4'),
          value: 'sweet_treats',
        },
        {
          text: t('pages.onboarding.questionCraving.button5'),
          value: 'plant_based',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
